import { render, staticRenderFns } from "./villageData.vue?vue&type=template&id=5528ce56&scoped=true&"
import script from "./villageData.vue?vue&type=script&lang=js&"
export * from "./villageData.vue?vue&type=script&lang=js&"
import style0 from "./villageData.vue?vue&type=style&index=0&id=5528ce56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5528ce56",
  null
  
)

export default component.exports